import { render, staticRenderFns } from "./TsoftChannels.vue?vue&type=template&id=ab4ab82e&scoped=true"
import script from "./TsoftChannels.vue?vue&type=script&lang=js"
export * from "./TsoftChannels.vue?vue&type=script&lang=js"
import style0 from "./TsoftChannels.vue?vue&type=style&index=0&id=ab4ab82e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4ab82e",
  null
  
)

export default component.exports